import { useQuery } from "@apollo/client";
import {
  Box,
  Card,
  Drawer,
  LoadingOverlay,
  ScrollArea,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import { GET_RETAILERS_LOAN_REPORT } from "apollo/queries";
import ActionButton from "components/controls/ActionButtonNew";
import B2bTable from "components/reusable/b2bTable";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { formatNumber } from "utiles/url";
import LoanRequestReportDetail from "./detail";

const LoanRequestReport = () => {
  const [size, setSize] = useState("10");
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [hasMounted, setHasMounted] = useState(false);
  const [retailer, setRetailer] = useState(null);
  const [openedDetail, setOpenedDetail] = useState(false);
  const [requestDetail, setRequestDetail] = useState(null);
  const theme = useMantineTheme();

  const [confirmedSearch, setConfirmedSearch] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const { data, loading, fetchMore, refetch } = useQuery(
    GET_RETAILERS_LOAN_REPORT,
    {
      variables: {
        first: parseInt(size),
        page: activePage,
        search: searchValue,
        user_id: parseInt(retailer),
        ordered_by: [{ column: "CREATED_AT", order: "DESC" }],
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message ||
            "Failed to get retailers loan report",
        });
      },
    },
  );

  const handleManualSearch = (searchTerm) => setSearchValue(searchTerm);
  const clearInput = () => {
    setSearchValue("");
    setConfirmedSearch("");
  };

  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
  };

  const handleChange = (currentPage) => {
    fetchMore({
      variables: { first: parseInt(size), page: currentPage },
    });
    setActivePage(currentPage);
  };

  useEffect(() => {
    setHasMounted(true);
    refetch();
  }, []);

  useEffect(() => {
    if (data) setTotal(data.getRetailersLoanReport.paginatorInfo.lastPage);
  }, [data, size]);

  if (!hasMounted) return null;

  const headerData = [
    {
      label: "Retailer",
      key: "name_user",
      width: "20%",
      render: (rowData) => <span>{rowData.retailer?.name}</span>,
    },
    {
      label: "Phone",
      key: "phone",
      render: (rowData) => <span>{rowData.retailer?.contact_phone}</span>,
    },
    {
      label: "TotalAmount",
      key: "total_amount",
      render: (rowData) => (
        <span>{formatNumber(rowData?.total_loans_amount)}</span>
      ),
    },
    {
      label: "Paid Amount",
      key: "paid_amount",
      width: "8%",
      render: (rowData) => (
        <span>{formatNumber(rowData?.total_paid_amount)}</span>
      ),
    },
    {
      label: "Remaining Amount",
      key: "remaining_amount",
      render: (rowData) => (
        <span>
          {formatNumber(
            rowData?.total_loans_amount - rowData?.total_paid_amount,
          )}
        </span>
      ),
    },
    {
      label: "Actions",
      key: "actions",
      sortable: false,
      searchable: false,
      render: (rowData) => {
        return (
          <div style={{ display: "flex", gap: "6px" }}>
            <ActionButton
              label="View"
              color="success"
              onClick={() => handleManageSales(rowData.loan_requests)}
            >
              <FiEye fontSize="medium" />
            </ActionButton>
          </div>
        );
      },
    },
  ];
  const handleManageSales = (rowData) => {
    setRequestDetail(rowData);
    setOpenedDetail(true);
  };
  console.log("requestDetail", requestDetail);
  return loading ? (
    <LoadingOverlay
      visible={loading}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Card shadow="sm" p="lg">
        <Drawer
          opened={openedDetail}
          onClose={() => setOpenedDetail(false)}
          overlayColor={
            theme.colorScheme === "dark"
              ? theme.colors.dark[9]
              : theme.colors.gray[2]
          }
          overlayOpacity={0.55}
          overlayBlur={3}
          title="Loan Request Report Details"
          padding="xl"
          size="80%"
          position="bottom"
        >
          <LoanRequestReportDetail
            refetch={refetch}
            setOpenedDetal={openedDetail}
            requestData={requestDetail}
          />
        </Drawer>
        <ScrollArea>
          <B2bTable
            total={total}
            paginatorInfo={data?.getRetailersLoanReport?.paginatorInfo}
            activePage={activePage}
            clearInput={clearInput}
            handelSearch={handleManualSearch}
            searchValue={confirmedSearch}
            onSearchChange={setConfirmedSearch}
            handleChange={handleChange}
            header={headerData}
            filterData={() => (
              <Box sx={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                {/* 
<RetailerFilter
  retailer={retailer}
  valueType={"user"}
  onCardClick={setRetailer}
/>
*/}
              </Box>
            )}
            loading={loading}
            data={data ? data.getRetailersLoanReport.data : []}
            handlePageSizeChange={handlePageSizeChange}
            size={size}
          />
        </ScrollArea>
      </Card>
    </div>
  );
};

export default LoanRequestReport;
